<template>

    <div>

        <el-row>
            <div class="left-justifying"><h3>签字附件记录</h3></div>
        </el-row>
        <div class="panel">
            <div class="panel-body">
                <el-row>
                    <el-tabs v-model="activeTab" @tab-click="handle_tab_click">
                        <el-tab-pane label="列表" name="tab_1">
                            <sign-record-page @queryDetail="queryDetail"></sign-record-page>
                        </el-tab-pane>
                        <el-tab-pane label="详情" name="tab_2">
                            <sign-record-detail :signRecordInfo="signRecordInfo" @afterQueryDetail="afterQueryDetail">
                            </sign-record-detail>
                        </el-tab-pane>
                    </el-tabs>
                </el-row>
            </div>
        </div>

    </div>
</template>

<script>


import signRecordPage from "./signRecordPage";
import signRecordDetail from "./signRecordDetail";

export default {
    name: "signRecord",

    components: {
        signRecordPage,
        signRecordDetail,
    },

    data() {
        return {
            activeTab: 'tab_1',

            signRecordInfo: {},
        }
    },

    methods: {
        handle_tab_click(tab, event) {
            this.activeTab = tab.name;
        },

        queryDetail(id) {
            this.signRecordInfo = {
                id: id,
            }
        },

        afterQueryDetail() {
            this.activeTab = 'tab_2';
        },
    }
}
</script>

<style scoped>

</style>